<template>
  <div class="col">
    <div class="row mt-5 ">
      <div class="col">
        <h5>{{picklocation.productName}} <br> {{$t('location.location')}} {{picklocation.name}}</h5>
        <p>{{order.packingListNumber}}</p>
      </div>
      <div class="col">
        <button class='btn btn-primary float-right'
                @click="goBack()"> {{$t('button.back')}}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="order-destination">
          <orderDestination :order="order"/>
        </div>
      </div>
    </div>
    <div class="row mt-5 ">
      <div class="col">
        <p>{{$t('shopfloor.teamlead.manual.description')}}</p>
        <strong v-if="picklocation.fullyPicked"
                class="fully-picked">{{$t('shopfloor.teamlead.manual.productloaded')}}</strong>
        <strong v-if="!picklocation.fullyPicked" class="not-fully-picked">
          {{$t('shopfloor.teamlead.manual.productNotLoaded')}}</strong>

      </div>
    </div>
    <div class="row mt-5 ">
      <div class="col-12">
        <div class="custom-control custom-checkbox">
          <input v-model="picklocation.barcodeUnreadable"
                 type="checkbox"
                 @change="barcodeUnreadableChanged = true;"
                 :id="picklocation.productNumber"
                 class="custom-control-input"
          />
          <label class="custom-control-label" :for="picklocation.productNumber">
            <span>{{$t('shopfloor.loadingPage.barcodeUnreadable')}}</span>
          </label>
        </div>
      </div>

    </div>

    <div class="row mt-5 ">
      <div class="col">
        <label for="description_pickable">{{$t('shopfloor.teamlead.manual.picklocation.amountPickedTitle')}} </label>
        <p id="description_pickable" v-html="$t('shopfloor.teamlead.manual.picklocation.description')"/>
      </div>
      <div class="col">
        <label for="amountPickable">{{$t('shopfloor.teamlead.manual.picklocation.amountPickable')}}</label>
        <div class="input-group input-group-lg">
          <div class="input-group-prepend">
            <button @click="picklocation.amountPickable--; toPickChange--" class="btn btn-default" id="inputGroup-sizing-lg11"
                    :disabled="disableAmountPickableDecrement"><i
                    class="fas fa-minus"/></button>
          </div>
          <input type="text" id="amountPickable" class="form-control" v-model="picklocation.amountPickable"
                 aria-label="Large" aria-describedby="inputGroup-sizing-sm">
          <div class="input-group-append">
            <button @click="picklocation.amountPickable++; toPickChange++" :disabled="disableAmountPickableIncrement"
                    class="btn btn-default" id="inputGroup-sizing-lg12">
              <i class="fas fa-plus"/>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5 ">
      <div class="col">
        <label for="description_picked_amount">{{$t('shopfloor.teamlead.manual.picklocation.pickedAmountTitle')}}</label>
        <p id="description_picked_amount"
           v-html="$t('shopfloor.teamlead.manual.picklocation.pickedAmountDescription')"/>

      </div>
      <div class="col">
        <label for="amountPickable">{{$t('shopfloor.teamlead.manual.picklocation.pickedAmount')}}</label>
        <div class="input-group input-group-lg">
          <div class="input-group-prepend">
            <button @click="picklocation.amountPicked--; pickedChange--;" class="btn btn-default" id="inputGroup-sizing-lg31"
                    :disabled="picklocation.amountPicked == 0"><i
                    class="fas fa-minus"/></button>
          </div>
          <input type="text" id="amountPicked" class="form-control" v-model="picklocation.amountPicked"
                 aria-label="Large" aria-describedby="inputGroup-sizing-sm">
          <div class="input-group-append">
            <button @click="picklocation.amountPicked++; pickedChange++;" class="btn btn-default" id="inputGroup-sizing-lg32"
                    :disabled="disableAmountPickedIncrement"
            ><i class="fas fa-plus"/></button>
          </div>
        </div>
      </div>

    </div>
    <div class="row mt-5 mb-5 ">
      <div class="col">
        <button class="btn btn-primary" @click="save()">Save</button>
      </div>

    </div>
  </div>

</template>


<script>
  import {mapGetters} from 'vuex';
  import orderDestination from './../../components/loading/OrderDestination';
  import {swalModals} from './../../mixins/swalModals';


  export default {
    props: ['order', 'product'],
    mixins: [swalModals],
    components: {
      orderDestination
    },
    data() {
      return {
        originalObject: undefined,
        picklocation: {},
        hasLocation: false,
        pickedChange: 0,
        toPickChange: 0,
        barcodeUnreadableChanged: false
      };
    },
    firestore() {
      return {
        picklocation: this.hasLocation ? null : this.$FB.collection('pick-locations').doc(this.product.locationId)
      };
    },
    computed: {
      ...mapGetters('users', [
        'getMeBasic'
      ]),
      disableAmountPickedIncrement() {
        let picklocation = this.picklocation;
        return picklocation.amountPicked >= picklocation.amountPickable ? true : false;

      },
      disableAmountPickableDecrement() {
        let picklocation = this.picklocation;
        return picklocation.amountPickable <= picklocation.amountPicked ? true : false;
      },
      disableAmountPickableIncrement() {
        let picklocation = this.picklocation;
        if(picklocation.amount === 0) {
          return false;
        }
        return picklocation.amountPickable >= picklocation.amount ? true : false;
      }
    },
    methods: {
      goBack() {
        if(this.hasChanges) {
          return this.swalUnsavedChanges().then(res => {
            if(res.value == true) {
                   this.$router.go(-1)
                  // this.$router.push({path: '/loading/cargo/' + this.order.cargoId + '?orderId=' + this.order.id});
            }
          });
        } else {
          this.$router.go(-1)
          // this.$router.push({path: '/loading/cargo/' + this.order.cargoId + '?orderId=' + this.order.id});
        }
      },
      async save() {
        if (this.toPickChange !== 0 || this.pickedChange !== 0 || this.barcodeUnreadableChanged) {
          await this.$FB.collection('manual-adjustments').add({
            manualChangesToPick: this.toPickChange,
            manualChangesPicked: this.pickedChange,
            user: this.getMeBasic,
            pickLocationAtThatTime: this.picklocation,
            adjustedAt: new Date(),
            packingListNumber: this.order.packingListNumber,
            productNumber: this.product.productNumber,
            companyId: this.getMeBasic.companyId,
            barcodeUnreadableChanged: this.barcodeUnreadableChanged,
            barcodeUnreadable: this.picklocation.barcodeUnreadable
          });
        }
        this.$FB.collection('pick-locations').doc(this.product.locationId).update({
          manualAdjustment: true,
          barcodeUnreadable: this.picklocation.barcodeUnreadable ?  this.picklocation.barcodeUnreadable : false ,
          amountPickable:  this.picklocation.amountPickable ? parseInt(this.picklocation.amountPickable)  : 0,
          amountPicked: this.picklocation.amountPicked ? parseInt(this.picklocation.amountPicked)  : 0,
        }).then(() => {
          this.hasChanges = false;
          this.$swal({
            customClass: {
              header: 'align-items-center'
            },
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 5000,
            type: 'success',
            title: this.$root.$t('shopfloor.teamlead.loading.saveSuccess')
          });
          this.goBack();
        });
      }
    },
    watch: {
      product(newV, oldV) {
        if(newV.name) {
          this.hasLocation = true;
          this.hasChanges = true;
        }
      },
      picklocation(newV, oldV) {
        this.originalObject = _.cloneDeep(newV);
        if(newV.name) {
          this.hasLocation = true;
        }
      },
      'picklocation.amountPickable': function (newV, oldV) {
        if (oldV !== undefined) {
          if (!_.isEqual(this.originalObject, this.picklocation)) {
            this.hasChanges = true;
          } else {
            this.hasChanges = false; // Changes are back to original, so no changes
          }
        }
      },
      'picklocation.barcodeUnreadable': function (newV, oldV) {
        if (oldV !== undefined) {
          if (!_.isEqual(this.originalObject, this.picklocation)) {
            this.hasChanges = true;
          } else {
            this.hasChanges = false; // Changes are back to original, so no changes
          }
        }
      },
      'picklocation.amountPicked': function (newV, oldV) {
        if (oldV !== undefined) {
          if (!_.isEqual(this.originalObject, this.picklocation)) {
            this.hasChanges = true;
          } else {
            this.hasChanges = false; // Changes are back to original, so no changes
          }
        }
      }
    },
    created() {
    }
  };
</script>

<style lang="scss" scoped>
  .fully-picked {
    color: green;
  }

  .not-fully-picked {
    color: red;
  }
</style>